export const newServiceMdalTrue =
    "eyJzdWIiOiJPUC05MDQ4OTg4MDA0NSIsImV4cCI6MTY3OTY2MDAzMX0eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzU";
export const newServiceMdalFalse =
    "gPxlbTxDsAFswwH21_tB7s8Ub2pL0zrFE-05yYaiUzDUf9wQMP6OL7yclGkILPqE3p45ntyyN0FI3-Go1ju_Yg";
export const tokenPage =
    "41f7ff53c1dc5cf4f3db1f33e026b2908cdf88b4a18443cb74060f334d1530c01fa21f12c92b19e5Y2MDAz";
